import {
  PRICE_MARGINS_RECEIVE_ALL_RULES,
  PRICE_MARGINS_RECEIVE_CATEGORIES,
  PRICE_MARGINS_RECEIVE_FILTERS,
  PRICE_MARGINS_RECEIVE_RULE,
  PRICE_MARGINS_RECEIVE_VALUE,
  PRICE_MARGINS_REMOVE_RULE,
  PRICE_MARGINS_RESET_FORM,
  PRICE_MARGINS_SET_ERROR,
  PRICE_MARGINS_SET_FILTER_VALUE,
  PRICE_MARGINS_SET_IS_LOADING,
  PRICE_MARGINS_SET_INFO_TEXT,
} from '../constants';

export const PRICE_MARGINS_DEFAULT_STATE = {
  rules: [],
  mainCategories: [],
  secondCategories: [],
  thirdCategories: [],
  filters: [],
  mainCategorySystemId: null,
  secondCategorySystemId: null,
  thirdCategorySystemId: null,
  isPercentage: true,
  marginValue: '',
  closestRoundingValue: '',
  formIsLoading: false,
  listingIsLoading: false,
  error: null,
  infoText: null,
};

export const priceMargins = (state = PRICE_MARGINS_DEFAULT_STATE, action) => {
  let rulesCopy;

  switch (action.type) {
    case PRICE_MARGINS_RECEIVE_RULE:
      rulesCopy = Object.assign([], state.rules);
      rulesCopy.push(action.payload);
      return {
        ...state,
        rules: rulesCopy,
      };

    case PRICE_MARGINS_REMOVE_RULE:
      rulesCopy = Object.assign([], state.rules);
      let ruleIndex = rulesCopy.findIndex((r) => r.id == action.payload);
      if (ruleIndex != -1) {
        rulesCopy.splice(ruleIndex, 1);
      }
      return {
        ...state,
        rules: rulesCopy,
      };

    case PRICE_MARGINS_SET_FILTER_VALUE:
      let filtersCopy = Object.assign([], state.filters);
      let filter = filtersCopy.find((f) => f.fieldId == action.payload.fieldId);
      if (filter) {
        filter.selectedValue = action.payload.value;
      }
      return {
        ...state,
        filters: filtersCopy,
      };

    case PRICE_MARGINS_RECEIVE_ALL_RULES:
    case PRICE_MARGINS_SET_ERROR:
    case PRICE_MARGINS_RECEIVE_FILTERS:
    case PRICE_MARGINS_RECEIVE_CATEGORIES:
    case PRICE_MARGINS_RECEIVE_VALUE:
    case PRICE_MARGINS_RESET_FORM:
    case PRICE_MARGINS_SET_IS_LOADING:
    case PRICE_MARGINS_SET_INFO_TEXT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
